import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { globalStyle } from "../../global/Utils";
import { getCompany } from "../../Actions/CompanyAction";
import { InvoiceLedgerModal } from "./InvoiceLedgerModal";
import { INVOICE_LEDGER, REPORT_GROUPS } from "./reportCatalog";

// The Reports tab: every report as a box, grouped. A box opens its report -
// its own page, or (Invoice Ledger) a pop-up over this one.
const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(null);

  const openReport = (report) => {
    if (report.path) {
      navigate(report.path);
      return;
    }
    // The pop-up asks which company; it needs the list first.
    if (report.modal === INVOICE_LEDGER) dispatch(getCompany("", "", ""));
    setOpenModal(report.modal);
  };

  return (
    <div className="w-full py-4 space-y-8">
      <h2
        className="text-center font-bold text-xl"
        style={{
          fontFamily: globalStyle.fontFamilyHeading,
          color: globalStyle.curveDarkColor,
        }}
      >
        Reports
      </h2>

      {REPORT_GROUPS.map((group) => {
        const headingId = `reports-${group.title.replace(/\s+/g, "-").toLowerCase()}`;
        return (
          <section key={group.title} aria-labelledby={headingId}>
            <h3
              id={headingId}
              className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500"
            >
              {group.title}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {group.reports.map((report) => (
                <button
                  key={report.title}
                  type="button"
                  onClick={() => openReport(report)}
                  className="group flex items-start gap-3 p-4 text-left rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md hover:border-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition-all duration-200"
                >
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-gray-100 text-gray-700 group-hover:bg-black group-hover:text-white transition">
                    {report.icon}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-semibold text-gray-800">
                      {report.title}
                    </span>
                    <span className="block mt-1 text-sm text-gray-500">
                      {report.description}
                    </span>
                  </span>
                  <span
                    aria-hidden="true"
                    className="self-center text-gray-400 group-hover:text-black transform group-hover:translate-x-1 transition"
                  >
                    →
                  </span>
                </button>
              ))}
            </div>
          </section>
        );
      })}

      <InvoiceLedgerModal
        isOpen={openModal !== null}
        onClose={() => setOpenModal(null)}
        title={openModal}
      />
    </div>
  );
};

export default Index;
